module.exports = __webpack_public_path__ + "static/media/futureskillscert.cc943c62.jpg";